module.exports = __webpack_public_path__ + "static/img/scene5.f36f7c37.jpg";